import React from 'react'

function TenderWhirlWL() {
    return (
        <embed src="\pdfs\E1.2.2_WL_Linear_whirl_outlet_12.2013_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderWhirlWL